import AccountShareModal, { ACCOUNT_SHARE_MODAL } from './modal';

export { ACCOUNT_SHARE_MODAL };

export default AccountShareModal;
